/* eslint-disable no-inner-declarations */
import Swiper, { Autoplay, Navigation, Thumbs, Scrollbar, Mousewheel } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let reviewsSwiperWr = document.querySelectorAll('.reviews-swiper-wr');

reviewsSwiperWr.forEach((el) => {
  if (el) {
    let itemsSwiperEl = el.querySelector('.reviews-sec__items .swiper');
    let swiperEl = el.querySelector('.reviews-sec__cards .swiper');
    let parentEl = el.parentElement;
    let nextEl = parentEl.querySelector('.swiper-button-next');
    let prevEl = parentEl.querySelector('.swiper-button-prev');
    let scrollbarEl = parentEl.querySelector('.reviews-sec__scrollbar');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');


    // thumbs
    let itemsSwiper = new Swiper(itemsSwiperEl, {
      modules: [Navigation, Thumbs, Scrollbar, Mousewheel],
      direction: 'vertical',
      spaceBetween: 0,
      slidesPerView: 4,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
      },
      mousewheel: {
        enabled: true,
      },
    });

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Thumbs],
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      thumbs: {
        swiper: itemsSwiper,
      },
    });

    function updateThumbsShadow() {
      const container = itemsSwiperEl.parentElement; 
      const total = swiper.slides.length;

      if (total < 4 || swiper.activeIndex >= 3) {
        container.classList.add('hide-shadow');
      } else {
        container.classList.remove('hide-shadow');
      }
    }

    swiper.on('slideChange slideChangeTransitionEnd', updateThumbsShadow);
    updateThumbsShadow();
  }
});